import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Roberto M.',
  location: 'Guadalajara, MX',
  title: '"La Mejor Colección de Planos Metálicos Que He Visto"',
  text: <>
        He comprado varios cursos y planos sueltos online y este es{' '}
        <span className="text-white font-bold" data-id="element-287">
          claramente el mejor paquete
        </span>{' '}
        en todos los aspectos. Los planos son super detallados y las
        instrucciones van al grano. Si estás empezando en la herrería, esto es
        lo primero que deberías comprar. El nivel de detalle te deja sin
        excusas.
      </>,
  rating: 5
}, {
  name: 'Daniel P.',
  location: 'Bogotá, CO',
  title: '"Planos Fáciles de Leer, a Diferencia de Otros..."',
  text: <>
        Recibí el paquete hace pocos días y no he podido dejar de revisarlo. Los
        esquemas a color con medidas exactas hacen que{' '}
        <span className="text-white font-bold" data-id="element-288">todo sea clarísimo.</span> A
        diferencia de otros planos que compré antes, estos realmente puedo
        entenderlos. Ya tengo 3 proyectos seleccionados para empezar esta
        semana.
      </>,
  rating: 5
}, {
  name: 'Miguel Á.',
  location: 'Lima, PE',
  title: '"Una Inversión Excelente Para Quien Empieza"',
  text: <>
        De todos los materiales que he comprado a lo largo de los años, esta es
        la mejor colección que tengo. Recurso excelente para principiantes y
        para herreros con experiencia. Incluye planos para muebles chicos,
        grandes, equipamiento de gym... Considerando la calidad y la cantidad,{' '}
        <span className="text-white font-bold" data-id="element-289">es una ganga absoluta.</span>
      </>,
  rating: 5
}, {
  name: 'Carlos R.',
  location: 'Santiago, CL',
  title: '"Me Habían Quemado Antes, Pero Esto Me Demostró Lo Contrario..."',
  text: <>
        Ya me habían estafado con cursos que prometen mucho y no enseñan nada
        práctico. Pero este paquete me demostró que estaba equivocado.{' '}
        <span className="text-white font-bold" data-id="element-290">
          Para un principiante, esto es un regalo del cielo:
        </span>{' '}
        cada detalle que necesitás, las herramientas, el proceso completo
        explicado. Si querés fabricar piezas de calidad, te debés a vos mismo
        conseguir este sistema.
      </>,
  rating: 5
}];
export function TestimonialGrid() {
  return <section className="py-12 px-4 bg-[#111]" style={{
    paddingTop: '0px',
    paddingBottom: '0px'
  }} data-id="element-291">
      <div className="max-w-7xl mx-auto" data-id="element-292">
        <div className="text-center mb-6" data-id="element-293">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-2" data-id="element-294">
            ESCUCHÁ LO QUE DICEN{' '}
            <span className="text-[#FF6B00]" data-id="element-295">NUESTROS CLIENTES</span>
          </h2>
          <p className="text-gray-400 text-base max-w-2xl mx-auto" data-id="element-296">
            No quiero que tomes MI palabra. Prefiero que veas lo que algunos
            compradores tienen que decir...
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-297">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#1a1a1a] p-5 rounded-xl border border-[#333] relative hover:border-[#FF6B00]/30 transition-colors shadow-lg" data-id="element-298">
              <Quote className="absolute top-5 right-5 w-8 h-8 text-[#333]" data-id="element-299" />
              <div className="flex mb-2" data-id="element-300">
                {[...Array(t.rating)].map((_, j) => <Star key={j} className="w-4 h-4 text-[#FF6B00] fill-current" data-id="element-301" />)}
              </div>
              <h3 className="text-white font-bold mb-2 text-lg leading-tight" data-id="element-302">
                {t.title}
              </h3>
              <p className="text-gray-400 mb-3 italic leading-relaxed text-sm md:text-base" data-id="element-303">
                "{t.text}"
              </p>
              <div className="border-t border-[#333] pt-3 flex items-center justify-between" data-id="element-304">
                <div data-id="element-305">
                  <p className="font-bold text-white text-sm" data-id="element-306">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-307">{t.location}</p>
                </div>
                <div className="text-xs text-[#22C55E] flex items-center font-bold bg-[#22C55E]/10 px-2 py-1 rounded-full" data-id="element-308">
                  <span className="w-2 h-2 bg-[#22C55E] rounded-full mr-2" data-id="element-309"></span>{' '}
                  Compra Verificada
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}